import React, { Component } from 'react';
import axios from '../../util/axios';
import { Link } from "react-router-dom";
import CobrandSelector from "../../components/cobrandselection/CobrandSelector";
import ThresholdTableOther from "../../components/snapshotdatamanagement/ThresholdTableOther";
import ThresholdTable from "../../components/snapshotdatamanagement/ThresholdTable";

class CobrandConfig extends Component {

	getCobrandById(cobrandId) {
		var cobrands = JSON.parse(localStorage.getItem('userData')).cobrands;
		var index = cobrands.findIndex(function(cobrand, i) {
			return (cobrand.id.toString() === cobrandId)
		});
		return (index > -1 ? cobrands[index] : cobrands[0]);
	}

	state = {
		cobrand: this.props.match ? this.getCobrandById(this.props.match.params.cobrandId) : JSON.parse(localStorage.getItem('userData')).cobrands[0],
		cobrandConfig: []
	};

	async componentDidMount() {
		const response = await axios.get("/api/cobConfig", {
			headers: {
				Authorization: JSON.parse(localStorage.getItem("userData")).token,
				"Cobrand-Id": this.state.cobrand.id
			}
		});
		const cobConfigResp = response.data.cobrandConfig;
		this.setState({ cobrandConfig: cobConfigResp });
	}

	handleBackNavigation = () => {
		window.location.href = "/applications/" + JSON.parse(localStorage.getItem("userData")).cobrands[0].id; 
	}	
	
	render() {
		console.log(this.state.cobrandConfig);

		return (
			<div className="container main">
				<div className="row mt-4 mb-2">
					<div className="col-md-4 ml-auto">
						<CobrandSelector />
					</div>
				</div>
				<div className="row mt-2">
					<div className="col heading">Cobrand Configuration </div>
				</div>
				<div className="row">
					<div className="col">
						{
							this.state.cobrandConfig.map((config) => (
								<React.Fragment>
									<div className="section-header mt-4 mb-2 ">Instance: { config.cobrand }</div>
									<div className="section-body">
										<div className="row mb-2">
											<div className="col col-6">
													{config.defaultSnapshotData && config.defaultSnapshotData.retrievalIntervalMonths === undefined &&
														<div class="row">
															<div className="col col-12 font-weight-bold">Snapshot PDF Enabled</div>
															<div className="col nameLabel">{ config.generateSnapshotPDF ? config.generateSnapshotPDF.toString() : 'false' }</div>
														</div>
													}
													{config.defaultSnapshotData && config.defaultSnapshotData.retrievalIntervalMonths != undefined &&
														<div class="row">
															<div className="col col-12 font-weight-bold">PDF Report Enabled</div>
															<div className="col nameLabel">{ config.generateSnapshotPDF ? config.generateSnapshotPDF.toString() : 'false' }</div>
														</div>
													}
											</div>
										
											<div className="col col-6">
											{config.defaultSnapshotData && config.defaultSnapshotData.recurringIncomeCalculation === undefined &&	
												<div class="row">
													<div className="col col-12 font-weight-bold">Statement Download Enabled</div>
													<div className="col nameLabel">{ config.docDownloadEnabled ? config.docDownloadEnabled.toString() : 'false' }</div>
												</div>
											}
											{config.defaultSnapshotData && config.defaultSnapshotData.recurringIncomeCalculation &&
												<div class="row">
												<div className="col col-12 font-weight-bold">Recurring Income Calculation</div>
												<div className="col nameLabel">{config.defaultSnapshotData.recurringIncomeCalculation}</div>
											</div>
											}
											</div>
										</div>

										<div className="row mb-2">
											<div className="col col-6">
											{config.defaultSnapshotData && config.defaultSnapshotData.topLineIncomeCalculationIntervalMonths === undefined &&	
												<div class="row">
													<div className="col col-12 font-weight-bold">Holding Type Classification</div>
													<div className="col nameLabel">{ config.classificationByHoldingType ? config.classificationByHoldingType.toString() : 'false' }</div>
												</div>
											}
											{config.defaultSnapshotData && config.defaultSnapshotData.topLineIncomeCalculationIntervalMonths != undefined &&	
												<div class="row">
													<div className="col col-12 font-weight-bold">Top Line Income Calculation Interval</div>
													<div className="col nameLabel">{config.defaultSnapshotData.topLineIncomeCalculationIntervalMonths} Months</div>
												</div>
											}
											</div>
											{ (config.fullNameMatch || config.lastNameMatch) &&
											<div className="col col-6 ">
												<div class="row">
													<div className="col col-12 font-weight-bold">Name Matching Algorithm</div>
													{
														config.fullNameMatch &&
														<div className="col">Full Name Match</div>
													}
													{
														config.lastNameMatch &&
														<div className="col">Last Name Match</div>
													}																									
												</div>
											</div>
											}											
										</div>
										<div className="row mb-2">
											<div className="col col-6">
												<div class="row">
													<div className="col col-12 font-weight-bold">Webhook Enabled</div>
													<div className="col nameLabel">{ config.webhook ? "true" : "false" }</div>
												</div>
											</div>
										
											{
											config.webhook && 
											<div className="col col-6">
												<div className="row">
													<div className="col col-12 font-weight-bold">Webhook URL</div>
													<div className="col">{ config.webhook.url }</div>
												</div>
											</div>

											}
										</div>

										<div className="row mb-2">
											{ config.defaultSnapshotData &&
											<div className="col col-6">
													{config.defaultSnapshotData && config.defaultSnapshotData.retrievalIntervalMonths === undefined &&
														<div class="row">
														<div className="col col-12 font-weight-bold">Snapshot Processed for</div>
														<div className="col nameLabel">{ config.defaultSnapshotData.days ? config.defaultSnapshotData.days + " days" : "Unavailable" }</div>
														</div>
													}
													{config.defaultSnapshotData && config.defaultSnapshotData.retrievalIntervalMonths != undefined &&
														<div class="row">
														<div className="col col-12 font-weight-bold">Report Processed for</div>
														<div className="col nameLabel">{ config.defaultSnapshotData.retrievalIntervalMonths ? config.defaultSnapshotData.retrievalIntervalMonths + " Months" : "Unavailable" }</div>
														</div>
													}
												
											</div>
											}
										
											{
											config.defaultSnapshotData && config.defaultSnapshotData.retrievalIntervalMonths === undefined &&
											<div className="col col-6">
												<div className="row">
													<div className="col col-12 font-weight-bold">Threshold Values</div>
													<div className="col nameLabel">{ config.defaultSnapshotData.largeCreditAmt ? "Large Credit Amount: $" + config.defaultSnapshotData.largeCreditAmt  : "Unavailable" }</div>
												</div>
												<div className="row">
													<div className="col nameLabel">{ config.defaultSnapshotData.lowBalAmt1 ? "Low Balance Amount 1: $" + config.defaultSnapshotData.lowBalAmt1  : "Unavailable" }</div>
												</div>
												<div className="row">
													<div className="col nameLabel">{ config.defaultSnapshotData.lowBalAmt2 ? "Low Balance Amount 2: $" + config.defaultSnapshotData.lowBalAmt2  : "Unavailable" }</div>
												</div>
												<div className="row">
													<div className="col nameLabel">{ config.defaultSnapshotData.lowBalAmt3 ? "Low Balance Amount 3: $" + config.defaultSnapshotData.lowBalAmt3  : "Unavailable" }</div>
												</div>
												<div className="row">
													<div className="col nameLabel">{ config.defaultSnapshotData.lowBalAmt4 ? "Low Balance Amount 4: $" + config.defaultSnapshotData.lowBalAmt4  : "Unavailable" }</div>
												</div>																																																
											</div>

											}
										</div>										
										{config.defaultSnapshotData && config.defaultSnapshotData.retrievalIntervalMonths != undefined &&
											<div className="row mb-2">
												<div className="col col-12 font-weight-bold">Thresholds</div>
												<div className="col col-12 mt-4 mb-2">
												<ThresholdTable data={config.defaultSnapshotData.thresholdArray} />
												</div>
											</div>
										}
									</div>
									
								</React.Fragment>
							))
						}
					</div>
				</div>
			</div>
		);
	}
}



export default CobrandConfig;